<template>
    <div class="mywrap">

        <div v-for="(attrItem, attrIndex) in menuList" :key="attrIndex">
            <div class="flex-1 oa-attr min-w-0" v-show="attrIndex === menuIndex">
                <div class="text-base oa-attr-title"
                    style="display: flex; align-items: center;justify-content: space-between;">
                    <div>菜单配置</div>
                    <div @click="handleDelMenu(menuIndex)">
                        <i class="el-icon-circle-close"></i>
                    </div>
                </div>

                <div>
                    <!-- 编辑子菜单 -->



                    <div class="flex items-center w-full p-4 mt-4 rounded bg-fill-light">

                        <OaMenuForm ref="menuRef" modular="master" :menuForm="attrItem">
                            <div class="flex-1">
                                <ul>
                                    <li class="flex" v-for="(subItem, subIndex) in attrItem.sub_button" :key="subIndex"
                                        style="padding: 8px; justify-content: space-between;">
                                        <span class="mr-auto">{{ subItem.name }}</span>
                                        <div class="flex">
                                            <div >
                                            <i class="el-icon-edit" @click="handleEditSubMenu(subItem, subIndex)"></i>

                                        </div>
                                        <div style="margin-left: 20px;">
                                            <i class="el-icon-delete"
                                                @click="handleDelSubMenu(menuIndex, subIndex)"></i>

                                        </div>
                                        </div>
                                       



                                    </li>
                                </ul>
                                <el-button type="primary" link :disabled="attrItem.sub_button.length >= 5"
                                    @click="handleAddSubMenu">
                                    添加子菜单({{ attrItem.sub_button.length }}/5)
                                </el-button>
                            </div>
                        </OaMenuForm>
                    </div>

                </div>
            </div>
        </div>
        <div v-if="dialogVisible">
            <OaMenuFormEdit :modular.sync="modular" :dialogVisible.sync="dialogVisible" @add="add" @edit="edit" :form1.sync="form1" @close="close">

            </OaMenuFormEdit>
        </div>
    </div>

</template>
<script>

import OaMenuFormEdit from './oa-menu-form-edit'
import OaMenuForm from './oa-menu-form'
export default {
    components: {
        OaMenuFormEdit,
        OaMenuForm
    },
    data() {
        return {
            dialogVisible: false,
            modular: 'add',
            form1:{},
            secIndex:0,
        }
    },
    props: {
        menuList: {
            type: Array,
            default: function () {
                return []
            }
        },
        menuIndex: {
            type: Number,
            default: 0
        }

    },
    watch: {
        menuList() {
            this.init()
        },
    },
    created() {

    },

    methods: {
        init() {
            console.log(this.menuList, 9090123)

        },
        handleAddMenu() {
            this.menuList.push({
                name: '菜单名称',
                has_menu: false,
                type: 'view',
                url: '',
                appid: '',
                pagepath: '',
                sub_button: []
            })
        },
        handleAddSubMenu(e) {
            this.modular = 'add'
            const index = this.menuIndex
            this.dialogVisible = true

            if (this.menuList[index].sub_button.length >= 5) {
                console.log('已添加上限～')
                return
            }
            // this.menuList[index].sub_button.push(e)
        },
        handleDelMenu(index) {
            if (index != 0) {
                this.menuIndex--
            }
            this.menuList.splice(index, 1)
        },
        handleEditSubMenu(event, subIndex) {
            this.modular = 'edit'
             this.secIndex=subIndex
            // const index = this.menuIndex
            this.form1=event
            console.log(this.form1,9999)

            this.dialogVisible = true
            this.update(this.menuList)


        },
        handleDelSubMenu(index, subIndex) {
            this.menuList[index].sub_button.splice(subIndex, 1)
            this.update(this.menuList)

        },
        add(data) {
            this.menuList[this.menuIndex].sub_button.push(data)
            this.dialogVisible = false
            this.update(this.menuList)

            
        },
        edit(data) {
            console.log(data)
            const index = this.secIndex
            for (let i = 0; i < this.menuList[index].sub_button.length; i++) {
                if (this.menuList[index].sub_button[i].id == data.id) {
                    this.menuList[index].sub_button[i] = data
                }
            }
            this.dialogVisible = false
            this.update(this.menuList)

        },
        close(){
            this.dialogVisible = false

        },
        update(e){
            // this.$emit('update:menuList', e)
            this.$emit('update', e)

        }
    }

};
</script>
<style lang="scss">
.flex {
    display: flex;
}

.items-center {
    align-items: center;
}

.justify-center {
    justify-content: center;
}

.flex-1 {
    flex: 1 1 0%；
}

.text-sm {
    font-size: 13px;
}

.text-base {
    font-size: 14px;
}

.mt-4 {
    margin-top: 20px
}

.p-4 {
    padding: 20px;
}

.mywrap {
    background: #f8f8f8;
    padding: 20px
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appmp/menu_com/oa-attr.vue